import { useContext, useState } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
// material
import { Alert, InputLabel, Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { MessageContext } from '../../../hoc/messageNotification';
// component
import { post } from '../../../api';

// ----------------------------------------------------------------------

export default function ForgetForm() {
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null)
  const { setErrorMessage } = useContext(MessageContext);

  const ForgotSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required')
  });

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: ForgotSchema,
    onSubmit: () => {
      post('api/auth/forgot-password', {}, `?email=${values.email}&url=http://localhost:3000/new-password`).then(res => setAlert('The message has been sent to your email'))
      .catch(e => setErrorMessage(e))
      setSubmitting(false)
    },
  });

  const { errors, touched, values, handleSubmit, isSubmitting, setSubmitting, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            autoComplete="username"
            type="email"
            id="email"
            placeholder="Email address"
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />
          {alert && <Alert>{alert}</Alert>}
          <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
            Send mail
          </LoadingButton>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
